import styled from "@emotion/styled";

import { fontRoboto } from "shared/lib/styles";

import { Tooltip, tooltipClasses } from "scmp-app/components/common/tooltip";

import IconInfo from "./icon-info.svg";

export const ClickAwayListenerWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledTooltip = styled(Tooltip)`
  & .${tooltipClasses.tooltip} {
    inline-size: 262px;
    max-inline-size: 262px;
    padding: 10px;

    border-radius: 4px;

    background-color: #001246;
  }

  & .${tooltipClasses.arrow} {
    color: #001246;
    font-size: 12px;
  }

  &&& .${tooltipClasses.tooltip} {
    margin-block-start: 8px;
  }
`;

export const TriggerButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: 24px;
  block-size: 24px;

  background-color: transparent;

  cursor: pointer;
`;

export const StyledIconInfo = styled(IconInfo)`
  inline-size: 20px;
  block-size: 20px;
`;

export const Message = styled.div`
  color: #ffffff;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: 1.3;
`;
